import { Button } from '@cian/ui-kit';
import { IconCommunicationMessage16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { useChats } from '../../hooks/useChats';
import { useSelector } from 'react-redux';
import { selectRecommendationById } from '../../selectors/recommendations/selectRecommendationById';

interface IProps {
  offerId: number;
  type?: 'full' | 'short';
}

export function ChatButtonContainer({ offerId, type = 'full' }: IProps) {
  const offer = useSelector(selectRecommendationById(offerId));

  const { isEnabled, openChat } = useChats(offer);

  if (!isEnabled) {
    return null;
  }

  if (type === 'short') {
    return (
      <Button
        onClick={() => openChat()}
        beforeIcon={<IconCommunicationMessage16 color="icon-main-default" />}
        theme="fill_secondary"
        size="L"
      />
    );
  }

  return (
    <Button onClick={() => openChat()} fullWidth size="M" theme="fill_secondary">
      Написать
    </Button>
  );
}
